import { MapPin, Phone } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SITE, TEL_HREF } from "@/siteConfig";

const COVERAGE_IMAGE = {
  url: "/images/city.webp",
  alt: "Prospettiva notturna di Roma con lampioni caldi",
};

export const Coverage = () => (
  <section
    id="zona"
    data-testid="coverage-section"
    className="scroll-mt-24 border-y border-white/[0.06] bg-[#0D1119] py-20 sm:py-28"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-7">
        <SectionHeading
          overline="Zona servita"
          title="Roma e provincia"
          lead="Interveniamo su Roma e sull'area della provincia. La disponibilità può variare in base alla zona e al tipo di intervento: per questo il primo passo è sempre una chiamata."
        />
        <Reveal delay={0.15}>
          <ul className="mt-8 space-y-4">
            <li className="flex items-start gap-3 text-zinc-300">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
              <span>
                Indicaci la tua zona al telefono: la verifica
                della disponibilità è immediata.
              </span>
            </li>
            <li className="flex items-start gap-3 text-zinc-300">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
              <span>
                Se il servizio è disponibile nella tua area, organizziamo
                l'intervento nella zona richiesta.
              </span>
            </li>
          </ul>
          <a
            href={TEL_HREF}
            data-testid="coverage-call-button"
            className="mt-8 inline-flex items-center gap-3 rounded-full border-2 border-amber-400/60 px-7 py-3.5 text-sm font-extrabold uppercase tracking-wide text-amber-300 transition-all hover:bg-amber-400/10 hover:border-amber-400"
          >
            <Phone className="h-4 w-4" />
            Verifica la tua zona · {SITE.phoneDisplay}
          </a>
        </Reveal>
      </div>
      <Reveal delay={0.2} className="lg:col-span-5">
        <div className="relative overflow-hidden rounded-3xl border border-white/10">
          <img
            src={COVERAGE_IMAGE.url}
            alt={COVERAGE_IMAGE.alt}
            loading="lazy"
            className="h-[300px] sm:h-[420px] w-full object-cover transition-transform duration-700 hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D12]/90 via-transparent to-transparent" />
          <p className="absolute bottom-4 left-4 font-tech text-[11px] uppercase tracking-[0.3em] text-amber-300">
            Roma + Provincia
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
